import React, { useState } from "react";
import axios from "axios";
import Constants from "./Constants";
import { Typography, TextField, Grid, Card } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import AlertMsg from "./component/AlertMsg";

function Login() {
	const [username, setUsername] = useState("");
	const [pass, setPass] = useState("");
	const [showError, setShowError] = useState(false);
	const [loading, setLoding] = useState(false);
	const [error, setError] = useState({
		header: "",
		message: "",
	});

	const handleUsernameChange = e => {
		setUsername(e.target.value);
	};

	const handlePassChange = e => {
		setPass(e.target.value);
	};

	const login = async event => {
		event.preventDefault();
		const data = {
			school: {
				username: username,
				password: pass,
			},
		};
		try {
			setLoding(true);
			let loginResponse = await axios.post(
				Constants.baseUrl + "/school/auth",
				data
			);
			const status = loginResponse.data.status;
			if (status === 202) {
				localStorage.setItem(
					"schoolToken",
					loginResponse.data.result.sessions.session.token
				);
				setLoding(false);
				window.location.assign("/school/admin");
			} else {
				setLoding(false);
				setError({
					header: "تلاش ناموفق",
					message: loginResponse.data.result.message,
				});
				setShowError(true);
			}
		} catch (err) {
			setLoding(false);
			setError({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط. مجدد تلاش کنید",
			});
			setShowError(true);
		}
	};

	return (
		<Grid container className="d-flex-column" height={"90vh"} width={"100%"}>
			<Grid item xs={11} sm={8} md={6} lg={3}>
				<Card sx={{ p: 4, borderRadius: "12px" }}>
					<Grid container spacing={2}>
						<Grid item xs={12} display={"flex"} justifyContent={"center"} mb={2}>
							<img
								alt="loginImage"
								src={require("./images/taraz-logo.png")}
								style={{ width: "50%", height: "100%" }}
							/>
						</Grid>
						{showError && <AlertMsg message={error} type={"error"} />}
						<Grid item xs={12}>
							<Typography variant="h5" fontSize={"18px"} mb={0.5}>
								نام کاربری
							</Typography>
							<TextField
								variant="outlined"
								value={username}
								onChange={handleUsernameChange}
								placeholder="نام کاربری"
								sx={{ width: "100%" }}
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5" fontSize={"18px"} mb={0.5}>
								گذرواژه
							</Typography>
							<TextField
								variant="outlined"
								value={pass}
								type="password"
								onChange={handlePassChange}
								placeholder="گذرواژه"
								sx={{ width: "100%" }}
							/>
						</Grid>
						<Grid item xs={12}>
							<LoadingButton
								variant="contained"
								color="secondary"
								onClick={login}
								loading={loading}
								sx={{ color: "white", width: "110px", fontSize: "18px" }}>
								ورود
							</LoadingButton>
						</Grid>
					</Grid>
				</Card>
				<Typography
					onClick={() => {
						window.open("/", "_self");
					}}
					sx={{ color: "white", cursor: "pointer", mt: 2 }}>
					بازگشت به صفحه اصلی
				</Typography>
			</Grid>
		</Grid>
	);
}

export default Login;
